/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /**
   * The `Date` scalar type represents a Date
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Date: { input: string; output: string };
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: { input: any; output: any };
  /** The `Decimal` scalar type represents a python Decimal. */
  Decimal: { input: string; output: string };
  /**
   * Allows use of a JSON String for input / output from the GraphQL schema.
   *
   * Use of this type is *not recommended* as you lose the benefits of having a defined, static
   * schema (one of the key benefits of GraphQL).
   */
  JSONString: { input: any; output: any };
  ObjectScalar: { input: any; output: any };
  /**
   * The `Time` scalar type represents a Time value as
   * specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Time: { input: any; output: any };
  /**
   * Leverages the internal Python implementation of UUID (uuid.UUID) to provide native UUID objects
   * in fields, resolvers and input.
   */
  UUID: { input: any; output: any };
};

/** An enumeration. */
export enum AccountDeaRegistrationStateCodeChoices {
  /** Alaska */
  Ak = 'AK',
  /** Alabama */
  Al = 'AL',
  /** Arkansas */
  Ar = 'AR',
  /** American Samoa */
  As = 'AS',
  /** Arizona */
  Az = 'AZ',
  /** California */
  Ca = 'CA',
  /** Colorado */
  Co = 'CO',
  /** Connecticut */
  Ct = 'CT',
  /** District Of Columbia */
  Dc = 'DC',
  /** Delaware */
  De = 'DE',
  /** Florida */
  Fl = 'FL',
  /** Federated States Of Micronesia */
  Fm = 'FM',
  /** Georgia */
  Ga = 'GA',
  /** Guam */
  Gu = 'GU',
  /** Hawaii */
  Hi = 'HI',
  /** Iowa */
  Ia = 'IA',
  /** Idaho */
  Id = 'ID',
  /** Illinois */
  Il = 'IL',
  /** Indiana */
  In = 'IN',
  /** Kansas */
  Ks = 'KS',
  /** Kentucky */
  Ky = 'KY',
  /** Louisiana */
  La = 'LA',
  /** Massachusetts */
  Ma = 'MA',
  /** Maryland */
  Md = 'MD',
  /** Maine */
  Me = 'ME',
  /** Marshall Islands */
  Mh = 'MH',
  /** Michigan */
  Mi = 'MI',
  /** Minnesota */
  Mn = 'MN',
  /** Missouri */
  Mo = 'MO',
  /** Northern Mariana Islands */
  Mp = 'MP',
  /** Mississippi */
  Ms = 'MS',
  /** Montana */
  Mt = 'MT',
  /** North Carolina */
  Nc = 'NC',
  /** North Dakota */
  Nd = 'ND',
  /** Nebraska */
  Ne = 'NE',
  /** New Hampshire */
  Nh = 'NH',
  /** New Jersey */
  Nj = 'NJ',
  /** New Mexico */
  Nm = 'NM',
  /** Nevada */
  Nv = 'NV',
  /** New York */
  Ny = 'NY',
  /** Ohio */
  Oh = 'OH',
  /** Oklahoma */
  Ok = 'OK',
  /** Oregon */
  Or = 'OR',
  /** Pennsylvania */
  Pa = 'PA',
  /** Puerto Rico */
  Pr = 'PR',
  /** Palau */
  Pw = 'PW',
  /** Rhode Island */
  Ri = 'RI',
  /** South Carolina */
  Sc = 'SC',
  /** South Dakota */
  Sd = 'SD',
  /** Tennessee */
  Tn = 'TN',
  /** Texas */
  Tx = 'TX',
  /** Utah */
  Ut = 'UT',
  /** Virginia */
  Va = 'VA',
  /** Virgin Islands */
  Vi = 'VI',
  /** Vermont */
  Vt = 'VT',
  /** Washington */
  Wa = 'WA',
  /** Wisconsin */
  Wi = 'WI',
  /** West Virginia */
  Wv = 'WV',
  /** Wyoming */
  Wy = 'WY',
}

/** An enumeration. */
export enum AccountVetLicenseStateCodeChoices {
  /** Alaska */
  Ak = 'AK',
  /** Alabama */
  Al = 'AL',
  /** Arkansas */
  Ar = 'AR',
  /** American Samoa */
  As = 'AS',
  /** Arizona */
  Az = 'AZ',
  /** California */
  Ca = 'CA',
  /** Colorado */
  Co = 'CO',
  /** Connecticut */
  Ct = 'CT',
  /** District Of Columbia */
  Dc = 'DC',
  /** Delaware */
  De = 'DE',
  /** Florida */
  Fl = 'FL',
  /** Federated States Of Micronesia */
  Fm = 'FM',
  /** Georgia */
  Ga = 'GA',
  /** Guam */
  Gu = 'GU',
  /** Hawaii */
  Hi = 'HI',
  /** Iowa */
  Ia = 'IA',
  /** Idaho */
  Id = 'ID',
  /** Illinois */
  Il = 'IL',
  /** Indiana */
  In = 'IN',
  /** Kansas */
  Ks = 'KS',
  /** Kentucky */
  Ky = 'KY',
  /** Louisiana */
  La = 'LA',
  /** Massachusetts */
  Ma = 'MA',
  /** Maryland */
  Md = 'MD',
  /** Maine */
  Me = 'ME',
  /** Marshall Islands */
  Mh = 'MH',
  /** Michigan */
  Mi = 'MI',
  /** Minnesota */
  Mn = 'MN',
  /** Missouri */
  Mo = 'MO',
  /** Northern Mariana Islands */
  Mp = 'MP',
  /** Mississippi */
  Ms = 'MS',
  /** Montana */
  Mt = 'MT',
  /** North Carolina */
  Nc = 'NC',
  /** North Dakota */
  Nd = 'ND',
  /** Nebraska */
  Ne = 'NE',
  /** New Hampshire */
  Nh = 'NH',
  /** New Jersey */
  Nj = 'NJ',
  /** New Mexico */
  Nm = 'NM',
  /** Nevada */
  Nv = 'NV',
  /** New York */
  Ny = 'NY',
  /** Ohio */
  Oh = 'OH',
  /** Oklahoma */
  Ok = 'OK',
  /** Oregon */
  Or = 'OR',
  /** Pennsylvania */
  Pa = 'PA',
  /** Puerto Rico */
  Pr = 'PR',
  /** Palau */
  Pw = 'PW',
  /** Rhode Island */
  Ri = 'RI',
  /** South Carolina */
  Sc = 'SC',
  /** South Dakota */
  Sd = 'SD',
  /** Tennessee */
  Tn = 'TN',
  /** Texas */
  Tx = 'TX',
  /** Utah */
  Ut = 'UT',
  /** Virginia */
  Va = 'VA',
  /** Virgin Islands */
  Vi = 'VI',
  /** Vermont */
  Vt = 'VT',
  /** Washington */
  Wa = 'WA',
  /** Wisconsin */
  Wi = 'WI',
  /** West Virginia */
  Wv = 'WV',
  /** Wyoming */
  Wy = 'WY',
}

/** An enumeration. */
export enum AccountVetProfileContractTypeChoices {
  /** 1099 Contract */
  A_1099 = 'A_1099',
  /** External Vet */
  External = 'EXTERNAL',
  /** W2 Contract (Full Time) */
  W2Full = 'W2_FULL',
  /** W2 Contract (Part Time) */
  W2Part = 'W2_PART',
}

/** An enumeration. */
export enum AccountVetProfileStateChoices {
  /** Alaska */
  Ak = 'AK',
  /** Alabama */
  Al = 'AL',
  /** Arkansas */
  Ar = 'AR',
  /** American Samoa */
  As = 'AS',
  /** Arizona */
  Az = 'AZ',
  /** California */
  Ca = 'CA',
  /** Colorado */
  Co = 'CO',
  /** Connecticut */
  Ct = 'CT',
  /** District Of Columbia */
  Dc = 'DC',
  /** Delaware */
  De = 'DE',
  /** Florida */
  Fl = 'FL',
  /** Federated States Of Micronesia */
  Fm = 'FM',
  /** Georgia */
  Ga = 'GA',
  /** Guam */
  Gu = 'GU',
  /** Hawaii */
  Hi = 'HI',
  /** Iowa */
  Ia = 'IA',
  /** Idaho */
  Id = 'ID',
  /** Illinois */
  Il = 'IL',
  /** Indiana */
  In = 'IN',
  /** Kansas */
  Ks = 'KS',
  /** Kentucky */
  Ky = 'KY',
  /** Louisiana */
  La = 'LA',
  /** Massachusetts */
  Ma = 'MA',
  /** Maryland */
  Md = 'MD',
  /** Maine */
  Me = 'ME',
  /** Marshall Islands */
  Mh = 'MH',
  /** Michigan */
  Mi = 'MI',
  /** Minnesota */
  Mn = 'MN',
  /** Missouri */
  Mo = 'MO',
  /** Northern Mariana Islands */
  Mp = 'MP',
  /** Mississippi */
  Ms = 'MS',
  /** Montana */
  Mt = 'MT',
  /** North Carolina */
  Nc = 'NC',
  /** North Dakota */
  Nd = 'ND',
  /** Nebraska */
  Ne = 'NE',
  /** New Hampshire */
  Nh = 'NH',
  /** New Jersey */
  Nj = 'NJ',
  /** New Mexico */
  Nm = 'NM',
  /** Nevada */
  Nv = 'NV',
  /** New York */
  Ny = 'NY',
  /** Ohio */
  Oh = 'OH',
  /** Oklahoma */
  Ok = 'OK',
  /** Oregon */
  Or = 'OR',
  /** Pennsylvania */
  Pa = 'PA',
  /** Puerto Rico */
  Pr = 'PR',
  /** Palau */
  Pw = 'PW',
  /** Rhode Island */
  Ri = 'RI',
  /** South Carolina */
  Sc = 'SC',
  /** South Dakota */
  Sd = 'SD',
  /** Tennessee */
  Tn = 'TN',
  /** Texas */
  Tx = 'TX',
  /** Utah */
  Ut = 'UT',
  /** Virginia */
  Va = 'VA',
  /** Virgin Islands */
  Vi = 'VI',
  /** Vermont */
  Vt = 'VT',
  /** Washington */
  Wa = 'WA',
  /** Wisconsin */
  Wi = 'WI',
  /** West Virginia */
  Wv = 'WV',
  /** Wyoming */
  Wy = 'WY',
}

export type AddInsurance = {
  error?: Maybe<MutationError>;
  success: Scalars['Boolean']['output'];
  vetProfile?: Maybe<VetProfileType>;
};

export type AddLicense = {
  error?: Maybe<MutationError>;
  success: Scalars['Boolean']['output'];
  vetProfile?: Maybe<VetProfileType>;
};

export type AddRegistration = {
  error?: Maybe<MutationError>;
  success: Scalars['Boolean']['output'];
  vetProfile?: Maybe<VetProfileType>;
};

export type BannerType = {
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  /** Link address for the CTA button in the banner in the DVM app */
  link?: Maybe<Scalars['String']['output']>;
  /**
   * If the location is not filled in,
   *         it will be considered as global and will overhide any local banner
   */
  location?: Maybe<LocationType>;
  radius: Scalars['Int']['output'];
  /** Full content of notification banner in the DVM app */
  text?: Maybe<Scalars['String']['output']>;
  /** Title of notification banner in the DVM app */
  title: Scalars['String']['output'];
};

export type BidCancelationReasonType = {
  id: Scalars['ID']['output'];
  reason: Scalars['String']['output'];
};

export type BidCancelationRequestType = {
  bid: BidType;
  created: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isRemoved: Scalars['Boolean']['output'];
  modified: Scalars['DateTime']['output'];
  otherReason?: Maybe<Scalars['String']['output']>;
  reason: BidCancelationReasonType;
  status: BidsBidCancelationRequestStatusChoices;
};

export type BidHistoryType = Node & {
  amount: Scalars['Decimal']['output'];
  created: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  profileType: BidsBidHistoryProfileTypeChoices;
};

export type BidInput = {
  amount: Scalars['Decimal']['input'];
  buyItNow?: InputMaybe<Scalars['Boolean']['input']>;
  isFullService?: InputMaybe<Scalars['Boolean']['input']>;
  isFullShift?: InputMaybe<Scalars['Boolean']['input']>;
  isRecommended?: InputMaybe<Scalars['Boolean']['input']>;
  optionalAreasOfPractice?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >;
  shiftId: Scalars['Int']['input'];
  shiftType?: InputMaybe<Scalars['String']['input']>;
};

export type BidReviewInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  concernIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  equipmentScore?: InputMaybe<Scalars['Int']['input']>;
  overallScore: Scalars['Int']['input'];
  teamScore?: InputMaybe<Scalars['Int']['input']>;
  wouldWorkAgain?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BidReviewMutation = {
  error?: Maybe<MutationError>;
  success: Scalars['Boolean']['output'];
};

export type BidType = Node & {
  amount: Scalars['Decimal']['output'];
  cancelationRequest?: Maybe<BidCancelationRequestType>;
  finalStatus: BidsBidFinalStatusChoices;
  history?: Maybe<Array<Maybe<BidHistoryType>>>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  isFullService?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if this is a full shift or half shift bid. */
  isFullShift: Scalars['Boolean']['output'];
  optionalAreasOfPractice?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  review?: Maybe<ShiftReviewType>;
  shift: ShiftInterface;
  shiftReviewShowed: Scalars['Boolean']['output'];
};

export type BidTypeConnection = {
  /** Contains the nodes in this connection. */
  edges: Array<BidTypeEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `BidType` and its cursor. */
export type BidTypeEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: BidType;
};

/** An enumeration. */
export enum BidsBidCancelationRequestStatusChoices {
  /** Approved */
  Approved = 'APPROVED',
  /** Declined */
  Declined = 'DECLINED',
  /** Expired */
  Expired = 'EXPIRED',
  /** In Review */
  InReview = 'IN_REVIEW',
}

/** An enumeration. */
export enum BidsBidFinalStatusChoices {
  /** Approved */
  Approved = 'APPROVED',
  /** Canceled */
  Canceled = 'CANCELED',
  /** Declined */
  Declined = 'DECLINED',
  /** In Review */
  InReview = 'IN_REVIEW',
  /** Withdrawn */
  Withdrawn = 'WITHDRAWN',
}

/** An enumeration. */
export enum BidsBidHistoryProfileTypeChoices {
  /** Admin */
  Admin = 'ADMIN',
  /** DVM */
  Dvm = 'DVM',
}

export type BuyItNowTokensInfo = {
  availableTokens?: Maybe<Scalars['Int']['output']>;
  expirationDate?: Maybe<Scalars['Date']['output']>;
  expiringTokens?: Maybe<Scalars['Int']['output']>;
  transactions?: Maybe<Array<Maybe<TokenTransactionType>>>;
};

export type CancelBidInput = {
  id: Scalars['Int']['input'];
};

export type CancelBidMutation = {
  bid?: Maybe<BidType>;
  error?: Maybe<MutationError>;
  success: Scalars['Boolean']['output'];
};

export type CancelBidRequestInput = {
  bidId: Scalars['Int']['input'];
  otherReason?: InputMaybe<Scalars['String']['input']>;
  reasonId?: InputMaybe<Scalars['Int']['input']>;
};

export type CancelBidRequestMutation = {
  cancelationRequest?: Maybe<BidCancelationRequestType>;
  error?: Maybe<MutationError>;
  success: Scalars['Boolean']['output'];
};

export type ClinicEventType = EventInterface & {
  date: Scalars['Date']['output'];
  endTime: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  isCanceled: Scalars['Boolean']['output'];
  location: LocationType;
  startTime: Scalars['Time']['output'];
};

/** An enumeration. */
export enum CommunicationContactRequestAnswerStateChoices {
  /** Alaska */
  Ak = 'AK',
  /** Alabama */
  Al = 'AL',
  /** Arkansas */
  Ar = 'AR',
  /** American Samoa */
  As = 'AS',
  /** Arizona */
  Az = 'AZ',
  /** California */
  Ca = 'CA',
  /** Colorado */
  Co = 'CO',
  /** Connecticut */
  Ct = 'CT',
  /** District Of Columbia */
  Dc = 'DC',
  /** Delaware */
  De = 'DE',
  /** Florida */
  Fl = 'FL',
  /** Federated States Of Micronesia */
  Fm = 'FM',
  /** Georgia */
  Ga = 'GA',
  /** Guam */
  Gu = 'GU',
  /** Hawaii */
  Hi = 'HI',
  /** Iowa */
  Ia = 'IA',
  /** Idaho */
  Id = 'ID',
  /** Illinois */
  Il = 'IL',
  /** Indiana */
  In = 'IN',
  /** Kansas */
  Ks = 'KS',
  /** Kentucky */
  Ky = 'KY',
  /** Louisiana */
  La = 'LA',
  /** Massachusetts */
  Ma = 'MA',
  /** Maryland */
  Md = 'MD',
  /** Maine */
  Me = 'ME',
  /** Marshall Islands */
  Mh = 'MH',
  /** Michigan */
  Mi = 'MI',
  /** Minnesota */
  Mn = 'MN',
  /** Missouri */
  Mo = 'MO',
  /** Northern Mariana Islands */
  Mp = 'MP',
  /** Mississippi */
  Ms = 'MS',
  /** Montana */
  Mt = 'MT',
  /** North Carolina */
  Nc = 'NC',
  /** North Dakota */
  Nd = 'ND',
  /** Nebraska */
  Ne = 'NE',
  /** New Hampshire */
  Nh = 'NH',
  /** New Jersey */
  Nj = 'NJ',
  /** New Mexico */
  Nm = 'NM',
  /** Nevada */
  Nv = 'NV',
  /** New York */
  Ny = 'NY',
  /** Ohio */
  Oh = 'OH',
  /** Oklahoma */
  Ok = 'OK',
  /** Oregon */
  Or = 'OR',
  /** Pennsylvania */
  Pa = 'PA',
  /** Puerto Rico */
  Pr = 'PR',
  /** Palau */
  Pw = 'PW',
  /** Rhode Island */
  Ri = 'RI',
  /** South Carolina */
  Sc = 'SC',
  /** South Dakota */
  Sd = 'SD',
  /** Tennessee */
  Tn = 'TN',
  /** Texas */
  Tx = 'TX',
  /** Utah */
  Ut = 'UT',
  /** Virginia */
  Va = 'VA',
  /** Virgin Islands */
  Vi = 'VI',
  /** Vermont */
  Vt = 'VT',
  /** Washington */
  Wa = 'WA',
  /** Wisconsin */
  Wi = 'WI',
  /** West Virginia */
  Wv = 'WV',
  /** Wyoming */
  Wy = 'WY',
}

/** An enumeration. */
export enum CommunicationContactRequestAnswerStatusChoices {
  /** Approved */
  Approved = 'APPROVED',
  /** Declined */
  Declined = 'DECLINED',
  /** In Review */
  InReview = 'IN_REVIEW',
}

/** An enumeration. */
export enum CommunicationContactRequestRequestTypeChoices {
  /** Ask address */
  Address = 'ADDRESS',
  /** Ask date */
  Date = 'DATE',
  /** Ask description */
  Description = 'DESCRIPTION',
  /** Ask email */
  Email = 'EMAIL',
}

/** An enumeration. */
export enum CommunicationContactRequestSectionChoices {
  /** Account */
  Account = 'ACCOUNT',
  /** Bids */
  Bids = 'BIDS',
  /** Career */
  Career = 'CAREER',
  /** Other */
  Other = 'OTHER',
  /** Payment */
  Payment = 'PAYMENT',
  /** Shifts */
  Shifts = 'SHIFTS',
}

/** Represents a dynamic config to be made available for client-side querying. */
export type ConfigType = {
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ContactRequestAnswerType = {
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  contactRequest: ContactRequestType;
  created: Scalars['DateTime']['output'];
  date?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isRemoved: Scalars['Boolean']['output'];
  modified: Scalars['DateTime']['output'];
  newEmail?: Maybe<Scalars['String']['output']>;
  state?: Maybe<CommunicationContactRequestAnswerStateChoices>;
  status: CommunicationContactRequestAnswerStatusChoices;
  unit?: Maybe<Scalars['String']['output']>;
  veterinarian: VetProfileType;
  zip?: Maybe<Scalars['String']['output']>;
};

export type ContactRequestType = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  requestType: CommunicationContactRequestRequestTypeChoices;
  section: CommunicationContactRequestSectionChoices;
  subject: Scalars['String']['output'];
};

export type CouponType = {
  /** Barcode number for the discount coupon. */
  barcode: Scalars['String']['output'];
  /** Discount percentage (%) based on the barcode number inserted above. */
  discountPercentage: Scalars['Int']['output'];
  /** The first day the coupon is effective. */
  effectiveDate: Scalars['Date']['output'];
  /** The first day the coupon is invalid. */
  expirationDate: Scalars['Date']['output'];
};

export type CouponViewMutation = {
  error?: Maybe<MutationError>;
  success: Scalars['Boolean']['output'];
  view?: Maybe<CouponViewType>;
};

export type CouponViewType = {
  viewedAt: Scalars['DateTime']['output'];
};

export type CreateBidMutation = {
  bids?: Maybe<Array<Maybe<BidType>>>;
  error?: Maybe<MutationError>;
  success: Scalars['Boolean']['output'];
};

export type CreateContactRequestAnswerInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contactRequest: Scalars['ID']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  isRemoved?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  newEmail?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<CommunicationContactRequestAnswerStateChoices>;
  status?: InputMaybe<CommunicationContactRequestAnswerStatusChoices>;
  unit?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type CreateContactRequestAnswerMutation = {
  contactRequestAnswer?: Maybe<ContactRequestAnswerType>;
};

export type CreateNetPromoterScoreMutation = {
  error?: Maybe<MutationError>;
  success: Scalars['Boolean']['output'];
};

export type CreateOnboardingVetProfileInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  documents?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  modified?: InputMaybe<Scalars['DateTime']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  preferences?: InputMaybe<Scalars['JSONString']['input']>;
  referralCode?: InputMaybe<Scalars['String']['input']>;
  referralSource?: InputMaybe<Scalars['ID']['input']>;
  shouldEmailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  shouldTextNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<OnboardingOnboardingVetProfileStateChoices>;
  status?: InputMaybe<OnboardingOnboardingVetProfileStatusChoices>;
  uid?: InputMaybe<Scalars['UUID']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type DeaRegistrationType = {
  document: Scalars['String']['output'];
  expirationDate: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  number: Scalars['String']['output'];
  stateCode: AccountDeaRegistrationStateCodeChoices;
  vetProfile: VetProfileType;
};

export type DeleteOnboardingDocumentMutation = {
  error?: Maybe<MutationError>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DispatchDistrictType = {
  allowBidGuidance: Scalars['Boolean']['output'];
  allowShiftInfoVisibility: Scalars['Boolean']['output'];
  clinicLeaders?: Maybe<Array<Maybe<StaffProfileType>>>;
  hospitalLeaders?: Maybe<Array<Maybe<StaffProfileType>>>;
  name: Scalars['String']['output'];
};

/** Debugging information for the current query. */
export type DjangoDebug = {
  /** Executed SQL queries for this API query. */
  sql?: Maybe<Array<Maybe<DjangoDebugSql>>>;
};

/** Represents a single database query made to a Django managed DB. */
export type DjangoDebugSql = {
  /** The Django database alias (e.g. 'default'). */
  alias: Scalars['String']['output'];
  /** Duration of this database query in seconds. */
  duration: Scalars['Float']['output'];
  /** Postgres connection encoding if available. */
  encoding?: Maybe<Scalars['String']['output']>;
  /** Whether this database query was a SELECT. */
  isSelect: Scalars['Boolean']['output'];
  /** Whether this database query took more than 10 seconds. */
  isSlow: Scalars['Boolean']['output'];
  /** Postgres isolation level if available. */
  isoLevel?: Maybe<Scalars['String']['output']>;
  /** JSON encoded database query parameters. */
  params: Scalars['String']['output'];
  /** The raw SQL of this query, without params. */
  rawSql: Scalars['String']['output'];
  /** The actual SQL sent to this database. */
  sql?: Maybe<Scalars['String']['output']>;
  /** Start time of this database query. */
  startTime: Scalars['Float']['output'];
  /** Stop time of this database query. */
  stopTime: Scalars['Float']['output'];
  /** Postgres transaction ID if available. */
  transId?: Maybe<Scalars['String']['output']>;
  /** Postgres transaction status if available. */
  transStatus?: Maybe<Scalars['String']['output']>;
  /** The type of database being used (e.g. postrgesql, mysql, sqlite). */
  vendor: Scalars['String']['output'];
};

/** An enumeration. */
export enum DocumentFaqSectionChoices {
  /** Account */
  Account = 'ACCOUNT',
  /** Bids */
  Bids = 'BIDS',
  /** Career */
  Career = 'CAREER',
  /** Other */
  Other = 'OTHER',
  /** Payment */
  Payment = 'PAYMENT',
  /** Shifts */
  Shifts = 'SHIFTS',
}

export type DocumentType = {
  document: Scalars['String']['output'];
  hasViewed?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type EditBidInput = {
  amount: Scalars['Decimal']['input'];
  id: Scalars['Int']['input'];
};

export type EditBidMutation = {
  bid?: Maybe<BidType>;
  error?: Maybe<MutationError>;
  success: Scalars['Boolean']['output'];
};

export type EditInsurance = {
  error?: Maybe<MutationError>;
  success: Scalars['Boolean']['output'];
  vetProfile?: Maybe<VetProfileType>;
};

export type EditLicense = {
  error?: Maybe<MutationError>;
  success: Scalars['Boolean']['output'];
  vetProfile?: Maybe<VetProfileType>;
};

export type EditRegistration = {
  error?: Maybe<MutationError>;
  success: Scalars['Boolean']['output'];
  vetProfile?: Maybe<VetProfileType>;
};

export type EditVetProfileMutation = {
  error?: Maybe<MutationError>;
  success: Scalars['Boolean']['output'];
  vetProfile?: Maybe<VetProfileType>;
};

export type EventInterface = {
  date: Scalars['Date']['output'];
  endTime: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  isCanceled: Scalars['Boolean']['output'];
  location: LocationType;
  startTime: Scalars['Time']['output'];
};

export type ExecutionError = {
  errorMessage: Scalars['String']['output'];
};

export type FaqType = {
  answer: Scalars['String']['output'];
  document?: Maybe<Scalars['String']['output']>;
  documentName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  link?: Maybe<Scalars['String']['output']>;
  linkLabel?: Maybe<Scalars['String']['output']>;
  question: Scalars['String']['output'];
  section: DocumentFaqSectionChoices;
};

export type FileSignatureInputType = {
  entity: SignatureEntity;
  fileType: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type GenerateUploadSignatures = {
  error?: Maybe<MutationError>;
  presignedPosts?: Maybe<Array<Maybe<Scalars['ObjectScalar']['output']>>>;
  success: Scalars['Boolean']['output'];
};

export type HospitalEventType = EventInterface &
  Node & {
    date: Scalars['Date']['output'];
    endDate: Scalars['Date']['output'];
    endTime: Scalars['Time']['output'];
    id: Scalars['ID']['output'];
    isCanceled: Scalars['Boolean']['output'];
    location: LocationType;
    startTime: Scalars['Time']['output'];
  };

export type HospitalShiftType = Node &
  ShiftInterface & {
    acceptedBid?: Maybe<BidType>;
    allowBuyItNowToken?: Maybe<Scalars['Boolean']['output']>;
    allowShiftBuyItNow?: Maybe<Scalars['Boolean']['output']>;
    bidCount: Scalars['Int']['output'];
    bidGuidanceText: Scalars['String']['output'];
    buyItNowAmount?: Maybe<Scalars['Int']['output']>;
    date: Scalars['Date']['output'];
    events: Array<EventInterface>;
    fullShiftPrice?: Maybe<Scalars['Int']['output']>;
    hasValidLicense: Scalars['Boolean']['output'];
    id: Scalars['ID']['output'];
    limitedShiftPrice?: Maybe<Scalars['Int']['output']>;
    maxBidRange?: Maybe<Scalars['Int']['output']>;
    minBidRange?: Maybe<Scalars['Int']['output']>;
    name: Scalars['String']['output'];
    shiftRequirements?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    shiftType: Scalars['String']['output'];
    status: Scalars['String']['output'];
  };

export type InsuranceInput = {
  document: Scalars['String']['input'];
  expirationDate: Scalars['Date']['input'];
  policyNumber: Scalars['String']['input'];
};

export type LicenseInput = {
  document: Scalars['String']['input'];
  expirationDate: Scalars['Date']['input'];
  number: Scalars['String']['input'];
  stateCode: StateCode;
};

export type LocationDetailsType = {
  availableAppointmentTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  dvmsPerShift?: Maybe<Scalars['Int']['output']>;
  equipmentTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  hospitalManager?: Maybe<Scalars['String']['output']>;
  hospitalWebsiteUrl?: Maybe<Scalars['String']['output']>;
  pace?: Maybe<Scalars['String']['output']>;
  paraStaffPerDvm?: Maybe<Scalars['Int']['output']>;
  petTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  selectedAppointmentTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** An enumeration. */
export enum LocationLocationStateChoices {
  /** Alaska */
  Ak = 'AK',
  /** Alabama */
  Al = 'AL',
  /** Arkansas */
  Ar = 'AR',
  /** American Samoa */
  As = 'AS',
  /** Arizona */
  Az = 'AZ',
  /** California */
  Ca = 'CA',
  /** Colorado */
  Co = 'CO',
  /** Connecticut */
  Ct = 'CT',
  /** District Of Columbia */
  Dc = 'DC',
  /** Delaware */
  De = 'DE',
  /** Florida */
  Fl = 'FL',
  /** Federated States Of Micronesia */
  Fm = 'FM',
  /** Georgia */
  Ga = 'GA',
  /** Guam */
  Gu = 'GU',
  /** Hawaii */
  Hi = 'HI',
  /** Iowa */
  Ia = 'IA',
  /** Idaho */
  Id = 'ID',
  /** Illinois */
  Il = 'IL',
  /** Indiana */
  In = 'IN',
  /** Kansas */
  Ks = 'KS',
  /** Kentucky */
  Ky = 'KY',
  /** Louisiana */
  La = 'LA',
  /** Massachusetts */
  Ma = 'MA',
  /** Maryland */
  Md = 'MD',
  /** Maine */
  Me = 'ME',
  /** Marshall Islands */
  Mh = 'MH',
  /** Michigan */
  Mi = 'MI',
  /** Minnesota */
  Mn = 'MN',
  /** Missouri */
  Mo = 'MO',
  /** Northern Mariana Islands */
  Mp = 'MP',
  /** Mississippi */
  Ms = 'MS',
  /** Montana */
  Mt = 'MT',
  /** North Carolina */
  Nc = 'NC',
  /** North Dakota */
  Nd = 'ND',
  /** Nebraska */
  Ne = 'NE',
  /** New Hampshire */
  Nh = 'NH',
  /** New Jersey */
  Nj = 'NJ',
  /** New Mexico */
  Nm = 'NM',
  /** Nevada */
  Nv = 'NV',
  /** New York */
  Ny = 'NY',
  /** Ohio */
  Oh = 'OH',
  /** Oklahoma */
  Ok = 'OK',
  /** Oregon */
  Or = 'OR',
  /** Pennsylvania */
  Pa = 'PA',
  /** Puerto Rico */
  Pr = 'PR',
  /** Palau */
  Pw = 'PW',
  /** Rhode Island */
  Ri = 'RI',
  /** South Carolina */
  Sc = 'SC',
  /** South Dakota */
  Sd = 'SD',
  /** Tennessee */
  Tn = 'TN',
  /** Texas */
  Tx = 'TX',
  /** Utah */
  Ut = 'UT',
  /** Virginia */
  Va = 'VA',
  /** Virgin Islands */
  Vi = 'VI',
  /** Vermont */
  Vt = 'VT',
  /** Washington */
  Wa = 'WA',
  /** Wisconsin */
  Wi = 'WI',
  /** West Virginia */
  Wv = 'WV',
  /** Wyoming */
  Wy = 'WY',
}

export type LocationPhotoType = {
  /** This is used to provide alt text for the image, for accessibility purposes. */
  description?: Maybe<Scalars['String']['output']>;
  /** File size cannot exceed 5MB. Accepted extensions: .jpg, .jpeg and .png */
  photo?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
};

export type LocationType = {
  city: Scalars['String']['output'];
  code: Scalars['String']['output'];
  details?: Maybe<LocationDetailsType>;
  dispatchDistrict: DispatchDistrictType;
  distance?: Maybe<Scalars['Int']['output']>;
  featuredReviews: Array<ShiftReviewType>;
  id: Scalars['ID']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  photos?: Maybe<Array<Maybe<LocationPhotoType>>>;
  state: LocationLocationStateChoices;
  street1: Scalars['String']['output'];
  timezone?: Maybe<Scalars['String']['output']>;
  zipCode: Scalars['String']['output'];
};

export type MarkDocumentAsRead = {
  document?: Maybe<DocumentType>;
  error?: Maybe<MutationError>;
  success: Scalars['Boolean']['output'];
};

export type Mutation = {
  addInsurance?: Maybe<AddInsurance>;
  addLicense?: Maybe<AddLicense>;
  addRegistration?: Maybe<AddRegistration>;
  bidReview?: Maybe<BidReviewMutation>;
  cancelBid?: Maybe<CancelBidMutation>;
  cancelBidRequest?: Maybe<CancelBidRequestMutation>;
  createBids?: Maybe<CreateBidMutation>;
  createContactRequestAnswer?: Maybe<CreateContactRequestAnswerMutation>;
  createNetPromoterScore?: Maybe<CreateNetPromoterScoreMutation>;
  editBid?: Maybe<EditBidMutation>;
  editInsurance?: Maybe<EditInsurance>;
  editLicense?: Maybe<EditLicense>;
  editRegistration?: Maybe<EditRegistration>;
  editVetProfile?: Maybe<EditVetProfileMutation>;
  generateUploadSignatures?: Maybe<GenerateUploadSignatures>;
  markDocumentAsRead?: Maybe<MarkDocumentAsRead>;
  onboardingDocumentDelete?: Maybe<DeleteOnboardingDocumentMutation>;
  onboardingInsuranceCreate?: Maybe<OnboardingInsuranceCreateMutation>;
  onboardingLicenseCreate?: Maybe<OnboardingLicenseCreateMutation>;
  onboardingRegistrationCreate?: Maybe<OnboardingRegistrationCreateMutation>;
  onboardingVetProfileCreate?: Maybe<OnboardingVetProfileCreateMutation>;
  onboardingVetProfileRecover?: Maybe<OnboardingVetProfileRecoverMutation>;
  onboardingVetProfileUpdate?: Maybe<OnboardingVetProfileUpdateMutation>;
  saveVetPreferences?: Maybe<SaveVetPreferences>;
  uncheckFirstAccess?: Maybe<UncheckFirstAccess>;
  verifyInfo?: Maybe<VerifyInfo>;
  viewCoupon?: Maybe<CouponViewMutation>;
};

export type MutationAddInsuranceArgs = {
  insurance: InsuranceInput;
};

export type MutationAddLicenseArgs = {
  license: LicenseInput;
};

export type MutationAddRegistrationArgs = {
  registration: RegistrationInput;
};

export type MutationBidReviewArgs = {
  bidId: Scalars['ID']['input'];
  bidReview?: InputMaybe<BidReviewInput>;
  reviewFromModal: Scalars['Boolean']['input'];
};

export type MutationCancelBidArgs = {
  bid: CancelBidInput;
};

export type MutationCancelBidRequestArgs = {
  cancelBidRequest: CancelBidRequestInput;
};

export type MutationCreateBidsArgs = {
  bids: Array<InputMaybe<BidInput>>;
};

export type MutationCreateContactRequestAnswerArgs = {
  input: CreateContactRequestAnswerInput;
};

export type MutationCreateNetPromoterScoreArgs = {
  npsScore?: InputMaybe<NetPromoterScoreInput>;
};

export type MutationEditBidArgs = {
  bid: EditBidInput;
};

export type MutationEditInsuranceArgs = {
  id: Scalars['ID']['input'];
  insurance: InsuranceInput;
};

export type MutationEditLicenseArgs = {
  id: Scalars['ID']['input'];
  license: LicenseInput;
};

export type MutationEditRegistrationArgs = {
  id: Scalars['ID']['input'];
  registration: RegistrationInput;
};

export type MutationEditVetProfileArgs = {
  vetProfile: VetProfileInput;
};

export type MutationGenerateUploadSignaturesArgs = {
  files: Array<InputMaybe<FileSignatureInputType>>;
};

export type MutationMarkDocumentAsReadArgs = {
  documentId: Scalars['ID']['input'];
};

export type MutationOnboardingDocumentDeleteArgs = {
  uid: Scalars['UUID']['input'];
};

export type MutationOnboardingInsuranceCreateArgs = {
  document: OnboardingDocumentInputType;
  documentType?: InputMaybe<Scalars['String']['input']>;
};

export type MutationOnboardingLicenseCreateArgs = {
  document: OnboardingDocumentInputType;
  documentType?: InputMaybe<Scalars['String']['input']>;
};

export type MutationOnboardingRegistrationCreateArgs = {
  document: OnboardingDocumentInputType;
  documentType?: InputMaybe<Scalars['String']['input']>;
};

export type MutationOnboardingVetProfileCreateArgs = {
  input: CreateOnboardingVetProfileInput;
};

export type MutationOnboardingVetProfileRecoverArgs = {
  email: Scalars['String']['input'];
};

export type MutationOnboardingVetProfileUpdateArgs = {
  uid: Scalars['UUID']['input'];
  updatedProfile: UpdateOnboardingVetProfileInput;
};

export type MutationSaveVetPreferencesArgs = {
  preferences: VetPreferencesInput;
};

export type MutationError = ExecutionError | ValidationErrors;

export type NetPromoterScoreInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  npsScore: Scalars['Int']['input'];
};

/** An object with an ID */
export type Node = {
  /** The ID of the object */
  id: Scalars['ID']['output'];
};

export type OnboardingDocumentInputType = {
  document: Scalars['String']['input'];
  vetProfileUid: Scalars['UUID']['input'];
};

export type OnboardingDocumentType = {
  document: Scalars['String']['output'];
  documentType: OnboardingOnboardingDocumentDocumentTypeChoices;
  uid: Scalars['UUID']['output'];
  vetProfile: OnboardingVetProfileType;
};

export type OnboardingInsuranceCreateMutation = {
  document?: Maybe<OnboardingDocumentType>;
  error?: Maybe<MutationError>;
  success: Scalars['Boolean']['output'];
};

export type OnboardingLicenseCreateMutation = {
  document?: Maybe<OnboardingDocumentType>;
  error?: Maybe<MutationError>;
  success: Scalars['Boolean']['output'];
};

/** An enumeration. */
export enum OnboardingOnboardingDocumentDocumentTypeChoices {
  /** Insurance */
  Insurance = 'INSURANCE',
  /** License */
  License = 'LICENSE',
  /** Registration */
  Registration = 'REGISTRATION',
}

/** An enumeration. */
export enum OnboardingOnboardingVetProfileStateChoices {
  /** Alaska */
  Ak = 'AK',
  /** Alabama */
  Al = 'AL',
  /** Arkansas */
  Ar = 'AR',
  /** American Samoa */
  As = 'AS',
  /** Arizona */
  Az = 'AZ',
  /** California */
  Ca = 'CA',
  /** Colorado */
  Co = 'CO',
  /** Connecticut */
  Ct = 'CT',
  /** District Of Columbia */
  Dc = 'DC',
  /** Delaware */
  De = 'DE',
  /** Florida */
  Fl = 'FL',
  /** Federated States Of Micronesia */
  Fm = 'FM',
  /** Georgia */
  Ga = 'GA',
  /** Guam */
  Gu = 'GU',
  /** Hawaii */
  Hi = 'HI',
  /** Iowa */
  Ia = 'IA',
  /** Idaho */
  Id = 'ID',
  /** Illinois */
  Il = 'IL',
  /** Indiana */
  In = 'IN',
  /** Kansas */
  Ks = 'KS',
  /** Kentucky */
  Ky = 'KY',
  /** Louisiana */
  La = 'LA',
  /** Massachusetts */
  Ma = 'MA',
  /** Maryland */
  Md = 'MD',
  /** Maine */
  Me = 'ME',
  /** Marshall Islands */
  Mh = 'MH',
  /** Michigan */
  Mi = 'MI',
  /** Minnesota */
  Mn = 'MN',
  /** Missouri */
  Mo = 'MO',
  /** Northern Mariana Islands */
  Mp = 'MP',
  /** Mississippi */
  Ms = 'MS',
  /** Montana */
  Mt = 'MT',
  /** North Carolina */
  Nc = 'NC',
  /** North Dakota */
  Nd = 'ND',
  /** Nebraska */
  Ne = 'NE',
  /** New Hampshire */
  Nh = 'NH',
  /** New Jersey */
  Nj = 'NJ',
  /** New Mexico */
  Nm = 'NM',
  /** Nevada */
  Nv = 'NV',
  /** New York */
  Ny = 'NY',
  /** Ohio */
  Oh = 'OH',
  /** Oklahoma */
  Ok = 'OK',
  /** Oregon */
  Or = 'OR',
  /** Pennsylvania */
  Pa = 'PA',
  /** Puerto Rico */
  Pr = 'PR',
  /** Palau */
  Pw = 'PW',
  /** Rhode Island */
  Ri = 'RI',
  /** South Carolina */
  Sc = 'SC',
  /** South Dakota */
  Sd = 'SD',
  /** Tennessee */
  Tn = 'TN',
  /** Texas */
  Tx = 'TX',
  /** Utah */
  Ut = 'UT',
  /** Virginia */
  Va = 'VA',
  /** Virgin Islands */
  Vi = 'VI',
  /** Vermont */
  Vt = 'VT',
  /** Washington */
  Wa = 'WA',
  /** Wisconsin */
  Wi = 'WI',
  /** West Virginia */
  Wv = 'WV',
  /** Wyoming */
  Wy = 'WY',
}

/** An enumeration. */
export enum OnboardingOnboardingVetProfileStatusChoices {
  /** Address */
  Address = 'ADDRESS',
  /** Complete */
  Complete = 'COMPLETE',
  /** Converted */
  Converted = 'CONVERTED',
  /** Documents */
  Documents = 'DOCUMENTS',
  /** Complete (In Progress) */
  Evaluation = 'EVALUATION',
  /** Initial */
  Initial = 'INITIAL',
  /** Not Interested */
  NotInterested = 'NOT_INTERESTED',
  /** Personal Information */
  PersonalInfo = 'PERSONAL_INFO',
  /** Referral */
  Referral = 'REFERRAL',
  /** Unqualified */
  Unqualified = 'UNQUALIFIED',
  /** Unresponsive */
  Unresponsive = 'UNRESPONSIVE',
}

export type OnboardingRegistrationCreateMutation = {
  document?: Maybe<OnboardingDocumentType>;
  error?: Maybe<MutationError>;
  success: Scalars['Boolean']['output'];
};

export type OnboardingVetProfileCreateMutation = {
  onboardingVetProfile?: Maybe<OnboardingVetProfileType>;
};

export type OnboardingVetProfileRecoverMutation = {
  error?: Maybe<MutationError>;
  success: Scalars['Boolean']['output'];
};

export type OnboardingVetProfileType = {
  address1: Scalars['String']['output'];
  address2: Scalars['String']['output'];
  city: Scalars['String']['output'];
  documents: Array<OnboardingDocumentType>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  preferences?: Maybe<Scalars['JSONString']['output']>;
  referralCode: Scalars['String']['output'];
  referralSource?: Maybe<ReferralSourceType>;
  shouldEmailNotifications: Scalars['Boolean']['output'];
  shouldTextNotifications: Scalars['Boolean']['output'];
  state?: Maybe<OnboardingOnboardingVetProfileStateChoices>;
  status?: Maybe<OnboardingOnboardingVetProfileStatusChoices>;
  uid: Scalars['UUID']['output'];
  zipcode: Scalars['String']['output'];
};

export type OnboardingVetProfileUpdateMutation = {
  error?: Maybe<MutationError>;
  onboardingVetProfile?: Maybe<OnboardingVetProfileType>;
  success: Scalars['Boolean']['output'];
};

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PayPlanType = {
  fullDayRate: Scalars['Decimal']['output'];
  id: Scalars['ID']['output'];
  partialDayRate: Scalars['Decimal']['output'];
};

/** An enumeration. */
export enum PricingTokenTransactionTransactionTypeChoices {
  /** Assignment */
  Assignment = 'ASSIGNMENT',
  /** Usage */
  Usage = 'USAGE',
}

export type Query = {
  _debug?: Maybe<DjangoDebug>;
  availableShifts: ShiftInterfaceConnection;
  banner?: Maybe<BannerType>;
  bid?: Maybe<BidType>;
  bidToReview?: Maybe<BidType>;
  buyItNowTokensInfo?: Maybe<BuyItNowTokensInfo>;
  cancelationReasons: Array<BidCancelationReasonType>;
  cancelationRequest?: Maybe<BidCancelationRequestType>;
  configs?: Maybe<Array<Maybe<ConfigType>>>;
  contactRequest?: Maybe<ContactRequestType>;
  contactRequestAnswers?: Maybe<Array<Maybe<ContactRequestAnswerType>>>;
  contactRequests: Array<ContactRequestType>;
  documents?: Maybe<Array<Maybe<DocumentType>>>;
  faq: Array<FaqType>;
  hospitalEvent?: Maybe<HospitalEventType>;
  hospitalShift?: Maybe<HospitalShiftType>;
  location?: Maybe<LocationType>;
  me?: Maybe<UserType>;
  myBids: BidTypeConnection;
  myPastShifts: ShiftInterfaceConnection;
  myShifts: Array<ShiftInterface>;
  myUpcomingShifts: ShiftInterfaceConnection;
  node?: Maybe<Node>;
  onboardingProfile?: Maybe<OnboardingVetProfileType>;
  recommendedShifts: ShiftInterfaceConnection;
  recruiterContact?: Maybe<Scalars['String']['output']>;
  referralSources?: Maybe<Array<Maybe<ReferralSourceType>>>;
  reviewConcerns: Array<ReviewConcernType>;
  run?: Maybe<RunType>;
  shift?: Maybe<ShiftInterface>;
  shiftProxy?: Maybe<ShiftProxyType>;
  shiftReview?: Maybe<ShiftReviewType>;
  validCoupon?: Maybe<CouponType>;
};

export type QueryAvailableShiftsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ShiftFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type QueryBidArgs = {
  id: Scalars['ID']['input'];
};

export type QueryCancelationRequestArgs = {
  bidId: Scalars['ID']['input'];
};

export type QueryContactRequestArgs = {
  id: Scalars['ID']['input'];
};

export type QueryContactRequestsArgs = {
  section?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFaqArgs = {
  section?: InputMaybe<Scalars['String']['input']>;
};

export type QueryHospitalEventArgs = {
  id: Scalars['ID']['input'];
};

export type QueryHospitalShiftArgs = {
  id: Scalars['ID']['input'];
};

export type QueryLocationArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryMyBidsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locationName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  shiftTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  states?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryMyPastShiftsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ShiftFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryMyShiftsArgs = {
  filters?: InputMaybe<ShiftFilterInput>;
};

export type QueryMyUpcomingShiftsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ShiftFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryNodeArgs = {
  id: Scalars['ID']['input'];
};

export type QueryOnboardingProfileArgs = {
  token?: InputMaybe<Scalars['String']['input']>;
};

export type QueryRecommendedShiftsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryRecruiterContactArgs = {
  state: Scalars['String']['input'];
};

export type QueryRunArgs = {
  id: Scalars['ID']['input'];
};

export type QueryShiftArgs = {
  id: Scalars['ID']['input'];
  shiftType: Scalars['String']['input'];
};

export type QueryShiftProxyArgs = {
  id: Scalars['ID']['input'];
  shiftType: Scalars['String']['input'];
};

export type QueryShiftReviewArgs = {
  bidId: Scalars['ID']['input'];
};

export type ReferralSourceType = {
  /** Does this referral source have an input field? */
  hasInput: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Label for the input field */
  inputLabel?: Maybe<Scalars['String']['output']>;
  /** Is the input field required? */
  isInputRequired: Scalars['Boolean']['output'];
  /** Name of the referral source */
  name: Scalars['String']['output'];
};

export type RegistrationInput = {
  document: Scalars['String']['input'];
  expirationDate: Scalars['Date']['input'];
  number: Scalars['String']['input'];
  stateCode: StateCode;
};

export type ReviewConcernType = {
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type RunType = Node &
  ShiftInterface & {
    acceptedBid?: Maybe<BidType>;
    allowBuyItNowToken?: Maybe<Scalars['Boolean']['output']>;
    allowShiftBuyItNow?: Maybe<Scalars['Boolean']['output']>;
    bidCount: Scalars['Int']['output'];
    bidGuidanceText: Scalars['String']['output'];
    buyItNowAmount?: Maybe<Scalars['Int']['output']>;
    clinicEvents: Array<ClinicEventType>;
    date: Scalars['Date']['output'];
    events: Array<EventInterface>;
    fullShiftPrice?: Maybe<Scalars['Int']['output']>;
    hasValidLicense: Scalars['Boolean']['output'];
    id: Scalars['ID']['output'];
    limitedShiftPrice?: Maybe<Scalars['Int']['output']>;
    maxBidRange?: Maybe<Scalars['Int']['output']>;
    minBidRange?: Maybe<Scalars['Int']['output']>;
    name: Scalars['String']['output'];
    shiftRequirements?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    shiftType: Scalars['String']['output'];
    status: Scalars['String']['output'];
  };

export type SaveVetPreferences = {
  error?: Maybe<MutationError>;
  success: Scalars['Boolean']['output'];
  vetProfile?: Maybe<VetProfileType>;
};

export type ShiftFilterInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  days?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  dispatchDistrict?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  locationName?: InputMaybe<Scalars['String']['input']>;
  miles?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onlyBuyItNow?: InputMaybe<Scalars['Boolean']['input']>;
  onlyLicensed?: InputMaybe<Scalars['Boolean']['input']>;
  petcoDistrict?: InputMaybe<Scalars['String']['input']>;
  shiftTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sort?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  zipCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ShiftInterface = {
  allowBuyItNowToken?: Maybe<Scalars['Boolean']['output']>;
  allowShiftBuyItNow?: Maybe<Scalars['Boolean']['output']>;
  bidCount: Scalars['Int']['output'];
  bidGuidanceText: Scalars['String']['output'];
  buyItNowAmount?: Maybe<Scalars['Int']['output']>;
  date: Scalars['Date']['output'];
  events: Array<EventInterface>;
  fullShiftPrice?: Maybe<Scalars['Int']['output']>;
  hasValidLicense: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  limitedShiftPrice?: Maybe<Scalars['Int']['output']>;
  maxBidRange?: Maybe<Scalars['Int']['output']>;
  minBidRange?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  shiftRequirements?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  shiftType: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type ShiftInterfaceConnection = {
  count?: Maybe<Scalars['Int']['output']>;
  /** Contains the nodes in this connection. */
  edges: Array<ShiftInterfaceEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ShiftInterface` and its cursor. */
export type ShiftInterfaceEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: ShiftInterface;
};

export type ShiftProxyType = Node &
  ShiftInterface & {
    acceptedBid?: Maybe<BidType>;
    allowBuyItNowToken?: Maybe<Scalars['Boolean']['output']>;
    allowShiftBuyItNow?: Maybe<Scalars['Boolean']['output']>;
    bidCount: Scalars['Int']['output'];
    bidGuidanceText: Scalars['String']['output'];
    buyItNowAmount?: Maybe<Scalars['Int']['output']>;
    canceledDt: Scalars['DateTime']['output'];
    closedDt: Scalars['DateTime']['output'];
    date: Scalars['Date']['output'];
    events: Array<EventInterface>;
    fullShiftPrice?: Maybe<Scalars['Int']['output']>;
    hasValidLicense: Scalars['Boolean']['output'];
    id: Scalars['ID']['output'];
    limitedShiftPrice?: Maybe<Scalars['Int']['output']>;
    maxBidRange?: Maybe<Scalars['Int']['output']>;
    minBidRange?: Maybe<Scalars['Int']['output']>;
    name: Scalars['String']['output'];
    openedDt: Scalars['DateTime']['output'];
    run?: Maybe<RunType>;
    shift?: Maybe<HospitalShiftType>;
    shiftRequirements?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    shiftType: Scalars['String']['output'];
    status: Scalars['String']['output'];
  };

export type ShiftReviewType = {
  comment?: Maybe<Scalars['String']['output']>;
  concerns?: Maybe<Array<Maybe<ReviewConcernType>>>;
  equipmentScore: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  overallScore: Scalars['Int']['output'];
  teamScore: Scalars['Int']['output'];
  wouldWorkAgain: Scalars['Boolean']['output'];
};

export enum SignatureEntity {
  Insurance = 'INSURANCE',
  License = 'LICENSE',
  OnboardingInsurance = 'ONBOARDING_INSURANCE',
  OnboardingLicense = 'ONBOARDING_LICENSE',
  OnboardingRegistration = 'ONBOARDING_REGISTRATION',
  Profile = 'PROFILE',
  Registration = 'REGISTRATION',
}

export type StaffProfileType = {
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
};

/** An enumeration. */
export enum StateCode {
  Ak = 'AK',
  Al = 'AL',
  Ar = 'AR',
  As = 'AS',
  Az = 'AZ',
  Ca = 'CA',
  Co = 'CO',
  Ct = 'CT',
  Dc = 'DC',
  De = 'DE',
  Fl = 'FL',
  Fm = 'FM',
  Ga = 'GA',
  Gu = 'GU',
  Hi = 'HI',
  Ia = 'IA',
  Id = 'ID',
  Il = 'IL',
  In = 'IN',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  Ma = 'MA',
  Md = 'MD',
  Me = 'ME',
  Mh = 'MH',
  Mi = 'MI',
  Mn = 'MN',
  Mo = 'MO',
  Mp = 'MP',
  Ms = 'MS',
  Mt = 'MT',
  Nc = 'NC',
  Nd = 'ND',
  Ne = 'NE',
  Nh = 'NH',
  Nj = 'NJ',
  Nm = 'NM',
  Nv = 'NV',
  Ny = 'NY',
  Oh = 'OH',
  Ok = 'OK',
  Or = 'OR',
  Pa = 'PA',
  Pr = 'PR',
  Pw = 'PW',
  Ri = 'RI',
  Sc = 'SC',
  Sd = 'SD',
  Tn = 'TN',
  Tx = 'TX',
  Ut = 'UT',
  Va = 'VA',
  Vi = 'VI',
  Vt = 'VT',
  Wa = 'WA',
  Wi = 'WI',
  Wv = 'WV',
  Wy = 'WY',
}

export type TokenTransactionType = {
  date?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  shift?: Maybe<ShiftInterface>;
  tokenAmount: Scalars['Int']['output'];
  transactionType: PricingTokenTransactionTransactionTypeChoices;
};

export type UncheckFirstAccess = {
  error?: Maybe<MutationError>;
  success: Scalars['Boolean']['output'];
  vetProfile?: Maybe<VetProfileType>;
};

export type UpdateOnboardingVetProfileInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  preferences?: InputMaybe<Scalars['JSONString']['input']>;
  referralCode?: InputMaybe<Scalars['String']['input']>;
  referralSource?: InputMaybe<Scalars['ID']['input']>;
  shouldEmailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  shouldTextNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type UserType = {
  dateJoined: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  vetProfile?: Maybe<VetProfileType>;
};

export type ValidationError = {
  field?: Maybe<Scalars['String']['output']>;
  messages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ValidationErrors = {
  validationErrors?: Maybe<Array<Maybe<ValidationError>>>;
};

export type VerifyInfo = {
  error?: Maybe<MutationError>;
  success: Scalars['Boolean']['output'];
  vetProfile?: Maybe<VetProfileType>;
};

export type VetInsuranceLicenseType = {
  document: Scalars['String']['output'];
  expirationDate: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  policyNumber: Scalars['String']['output'];
  vetProfile: VetProfileType;
};

export type VetLicenseType = {
  document: Scalars['String']['output'];
  expirationDate: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  number: Scalars['String']['output'];
  stateCode: AccountVetLicenseStateCodeChoices;
  vetProfile: VetProfileType;
};

export type VetPreferencesInput = {
  preferences: Scalars['JSONString']['input'];
};

export type VetPreferencesType = {
  id: Scalars['ID']['output'];
  preferences: Scalars['JSONString']['output'];
};

export type VetProfileInput = {
  automaticallyAddRunsToCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  profilePic?: InputMaybe<Scalars['String']['input']>;
  textNotifications?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VetProfileType = {
  address?: Maybe<Scalars['String']['output']>;
  /** Allow Buy It Now by the DVM. */
  allowBuyItNow: Scalars['Boolean']['output'];
  askForNetPromoterScore?: Maybe<Scalars['Boolean']['output']>;
  askForShiftPreferences?: Maybe<Scalars['Boolean']['output']>;
  automaticallyAddRunsToCalendar: Scalars['Boolean']['output'];
  availableTokenCount?: Maybe<Scalars['Int']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  clinics?: Maybe<Scalars['Int']['output']>;
  /** Please select if this is a Petco employee (W2), independent contractor (1099) or external vet from relief agency (External Vet). */
  contractType: AccountVetProfileContractTypeChoices;
  deaRegistrations: Array<DeaRegistrationType>;
  emailNotifications?: Maybe<Scalars['Boolean']['output']>;
  firstAccess: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  insurances: Array<VetInsuranceLicenseType>;
  licenses: Array<VetLicenseType>;
  /** This information is available with the HR team and it will help define the bid rate for the W2 vets. */
  payPlan?: Maybe<PayPlanType>;
  /** This field stores the 'onPremisesSamAccountName' field from Petco AAD Tenant */
  petcoUserId?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
  preferences?: Maybe<VetPreferencesType>;
  profilePic?: Maybe<Scalars['String']['output']>;
  state?: Maybe<AccountVetProfileStateChoices>;
  textNotifications?: Maybe<Scalars['Boolean']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  user: UserType;
  verifiedInfo: Scalars['Boolean']['output'];
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type VetProfileTypeClinicsArgs = {
  year: Scalars['Int']['input'];
};

export type VetProfileTypeTotalArgs = {
  year: Scalars['Int']['input'];
};

export type BidFinalStatusQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type BidFinalStatusQuery = {
  bid?: { id: string; finalStatus: BidsBidFinalStatusChoices } | null;
};

export type GetMyBidsQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  shiftTypes?: InputMaybe<
    | Array<InputMaybe<Scalars['String']['input']>>
    | InputMaybe<Scalars['String']['input']>
  >;
  status?: InputMaybe<
    | Array<InputMaybe<Scalars['String']['input']>>
    | InputMaybe<Scalars['String']['input']>
  >;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  locationName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<
    | Array<InputMaybe<Scalars['String']['input']>>
    | InputMaybe<Scalars['String']['input']>
  >;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetMyBidsQuery = {
  myBids: {
    pageInfo: { endCursor?: string | null; hasNextPage: boolean };
    edges: Array<{
      node: {
        __typename: 'BidType';
        id: string;
        amount: string;
        finalStatus: BidsBidFinalStatusChoices;
        shift:
          | {
              id: string;
              name: string;
              date: string;
              shiftType: string;
              buyItNowAmount?: number | null;
              allowShiftBuyItNow?: boolean | null;
              allowBuyItNowToken?: boolean | null;
              bidGuidanceText: string;
              minBidRange?: number | null;
              maxBidRange?: number | null;
              events: Array<
                | {
                    id: string;
                    date: string;
                    startTime: any;
                    endTime: any;
                    location: {
                      id: string;
                      name: string;
                      street1: string;
                      state: LocationLocationStateChoices;
                      zipCode: string;
                      details?: { pace?: string | null } | null;
                      featuredReviews: Array<{
                        id: string;
                        overallScore: number;
                        comment?: string | null;
                      }>;
                    };
                  }
                | {
                    id: string;
                    date: string;
                    startTime: any;
                    endTime: any;
                    location: {
                      id: string;
                      name: string;
                      street1: string;
                      state: LocationLocationStateChoices;
                      zipCode: string;
                      details?: { pace?: string | null } | null;
                      featuredReviews: Array<{
                        id: string;
                        overallScore: number;
                        comment?: string | null;
                      }>;
                    };
                  }
              >;
            }
          | {
              id: string;
              name: string;
              date: string;
              shiftType: string;
              buyItNowAmount?: number | null;
              allowShiftBuyItNow?: boolean | null;
              allowBuyItNowToken?: boolean | null;
              bidGuidanceText: string;
              minBidRange?: number | null;
              maxBidRange?: number | null;
              events: Array<
                | {
                    id: string;
                    date: string;
                    startTime: any;
                    endTime: any;
                    location: {
                      id: string;
                      name: string;
                      street1: string;
                      state: LocationLocationStateChoices;
                      zipCode: string;
                      details?: { pace?: string | null } | null;
                      featuredReviews: Array<{
                        id: string;
                        overallScore: number;
                        comment?: string | null;
                      }>;
                    };
                  }
                | {
                    id: string;
                    date: string;
                    startTime: any;
                    endTime: any;
                    location: {
                      id: string;
                      name: string;
                      street1: string;
                      state: LocationLocationStateChoices;
                      zipCode: string;
                      details?: { pace?: string | null } | null;
                      featuredReviews: Array<{
                        id: string;
                        overallScore: number;
                        comment?: string | null;
                      }>;
                    };
                  }
              >;
            }
          | {
              id: string;
              name: string;
              date: string;
              shiftType: string;
              buyItNowAmount?: number | null;
              allowShiftBuyItNow?: boolean | null;
              allowBuyItNowToken?: boolean | null;
              bidGuidanceText: string;
              minBidRange?: number | null;
              maxBidRange?: number | null;
              events: Array<
                | {
                    id: string;
                    date: string;
                    startTime: any;
                    endTime: any;
                    location: {
                      id: string;
                      name: string;
                      street1: string;
                      state: LocationLocationStateChoices;
                      zipCode: string;
                      details?: { pace?: string | null } | null;
                      featuredReviews: Array<{
                        id: string;
                        overallScore: number;
                        comment?: string | null;
                      }>;
                    };
                  }
                | {
                    id: string;
                    date: string;
                    startTime: any;
                    endTime: any;
                    location: {
                      id: string;
                      name: string;
                      street1: string;
                      state: LocationLocationStateChoices;
                      zipCode: string;
                      details?: { pace?: string | null } | null;
                      featuredReviews: Array<{
                        id: string;
                        overallScore: number;
                        comment?: string | null;
                      }>;
                    };
                  }
              >;
            };
      };
    }>;
  };
};

export type OpenShiftsQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<ShiftFilterInput>;
  sort?: InputMaybe<Scalars['String']['input']>;
}>;

export type OpenShiftsQuery = {
  availableShifts: {
    pageInfo: { endCursor?: string | null; hasNextPage: boolean };
    edges: Array<{
      node:
        | {
            __typename: 'HospitalShiftType';
            bidCount: number;
            id: string;
            date: string;
            name: string;
            shiftType: string;
            hasValidLicense: boolean;
            bidGuidanceText: string;
            minBidRange?: number | null;
            maxBidRange?: number | null;
            status: string;
            allowShiftBuyItNow?: boolean | null;
            allowBuyItNowToken?: boolean | null;
            buyItNowAmount?: number | null;
            events: Array<
              | {
                  id: string;
                  startTime: any;
                  endTime: any;
                  date: string;
                  location: {
                    id: string;
                    name: string;
                    street1: string;
                    state: LocationLocationStateChoices;
                    zipCode: string;
                    details?: { pace?: string | null } | null;
                    dispatchDistrict: { allowShiftInfoVisibility: boolean };
                    featuredReviews: Array<{
                      id: string;
                      overallScore: number;
                      comment?: string | null;
                    }>;
                  };
                }
              | {
                  id: string;
                  startTime: any;
                  endTime: any;
                  date: string;
                  location: {
                    id: string;
                    name: string;
                    street1: string;
                    state: LocationLocationStateChoices;
                    zipCode: string;
                    details?: { pace?: string | null } | null;
                    dispatchDistrict: { allowShiftInfoVisibility: boolean };
                    featuredReviews: Array<{
                      id: string;
                      overallScore: number;
                      comment?: string | null;
                    }>;
                  };
                }
            >;
          }
        | {
            __typename: 'RunType';
            bidCount: number;
            id: string;
            date: string;
            name: string;
            shiftType: string;
            hasValidLicense: boolean;
            bidGuidanceText: string;
            minBidRange?: number | null;
            maxBidRange?: number | null;
            status: string;
            allowShiftBuyItNow?: boolean | null;
            allowBuyItNowToken?: boolean | null;
            buyItNowAmount?: number | null;
            events: Array<
              | {
                  id: string;
                  startTime: any;
                  endTime: any;
                  date: string;
                  location: {
                    id: string;
                    name: string;
                    street1: string;
                    state: LocationLocationStateChoices;
                    zipCode: string;
                    details?: { pace?: string | null } | null;
                    dispatchDistrict: { allowShiftInfoVisibility: boolean };
                    featuredReviews: Array<{
                      id: string;
                      overallScore: number;
                      comment?: string | null;
                    }>;
                  };
                }
              | {
                  id: string;
                  startTime: any;
                  endTime: any;
                  date: string;
                  location: {
                    id: string;
                    name: string;
                    street1: string;
                    state: LocationLocationStateChoices;
                    zipCode: string;
                    details?: { pace?: string | null } | null;
                    dispatchDistrict: { allowShiftInfoVisibility: boolean };
                    featuredReviews: Array<{
                      id: string;
                      overallScore: number;
                      comment?: string | null;
                    }>;
                  };
                }
            >;
          }
        | {
            __typename: 'ShiftProxyType';
            bidCount: number;
            id: string;
            date: string;
            name: string;
            shiftType: string;
            hasValidLicense: boolean;
            bidGuidanceText: string;
            minBidRange?: number | null;
            maxBidRange?: number | null;
            status: string;
            allowShiftBuyItNow?: boolean | null;
            allowBuyItNowToken?: boolean | null;
            buyItNowAmount?: number | null;
            events: Array<
              | {
                  id: string;
                  startTime: any;
                  endTime: any;
                  date: string;
                  location: {
                    id: string;
                    name: string;
                    street1: string;
                    state: LocationLocationStateChoices;
                    zipCode: string;
                    details?: { pace?: string | null } | null;
                    dispatchDistrict: { allowShiftInfoVisibility: boolean };
                    featuredReviews: Array<{
                      id: string;
                      overallScore: number;
                      comment?: string | null;
                    }>;
                  };
                }
              | {
                  id: string;
                  startTime: any;
                  endTime: any;
                  date: string;
                  location: {
                    id: string;
                    name: string;
                    street1: string;
                    state: LocationLocationStateChoices;
                    zipCode: string;
                    details?: { pace?: string | null } | null;
                    dispatchDistrict: { allowShiftInfoVisibility: boolean };
                    featuredReviews: Array<{
                      id: string;
                      overallScore: number;
                      comment?: string | null;
                    }>;
                  };
                }
            >;
          };
    }>;
  };
};

export type PlaceBidsMutationVariables = Exact<{
  bids: Array<InputMaybe<BidInput>> | InputMaybe<BidInput>;
}>;

export type PlaceBidsMutation = {
  createBids?: {
    success: boolean;
    error?:
      | { __typename: 'ExecutionError' }
      | {
          __typename: 'ValidationErrors';
          validationErrors?: Array<{
            field?: string | null;
            messages?: Array<string | null> | null;
          } | null> | null;
        }
      | null;
  } | null;
};

export type UpdateBidMutationVariables = Exact<{
  bid: EditBidInput;
}>;

export type UpdateBidMutation = {
  editBid?: {
    success: boolean;
    bid?: { id: string; amount: string } | null;
  } | null;
};

export type WithdrawBidMutationVariables = Exact<{
  bid: CancelBidInput;
}>;

export type WithdrawBidMutation = {
  cancelBid?: {
    success: boolean;
    bid?: { id: string; finalStatus: BidsBidFinalStatusChoices } | null;
  } | null;
};

export type ContactRequestQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type ContactRequestQuery = {
  contactRequest?: {
    id: string;
    requestType: CommunicationContactRequestRequestTypeChoices;
    subject: string;
  } | null;
};

export type ContactRequestsQueryVariables = Exact<{ [key: string]: never }>;

export type ContactRequestsQuery = {
  contactRequests: Array<{
    id: string;
    requestType: CommunicationContactRequestRequestTypeChoices;
    section: CommunicationContactRequestSectionChoices;
    subject: string;
  }>;
};

export type FaqSectionQueryVariables = Exact<{
  section?: InputMaybe<Scalars['String']['input']>;
}>;

export type FaqSectionQuery = {
  faq: Array<{
    id: string;
    question: string;
    answer: string;
    linkLabel?: string | null;
    link?: string | null;
    documentName?: string | null;
    document?: string | null;
  }>;
  contactRequests: Array<{
    id: string;
    requestType: CommunicationContactRequestRequestTypeChoices;
    subject: string;
  }>;
};

export type SubmitContactRequestMutationVariables = Exact<{
  input: CreateContactRequestAnswerInput;
}>;

export type SubmitContactRequestMutation = {
  createContactRequestAnswer?: {
    contactRequestAnswer?: { id: string } | null;
  } | null;
};

export type CancelationReasonsQueryVariables = Exact<{ [key: string]: never }>;

export type CancelationReasonsQuery = {
  cancelationReasons: Array<{ id: string; reason: string }>;
};

export type PastShiftReviewsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  shiftType: Scalars['String']['input'];
}>;

export type PastShiftReviewsQuery = {
  shift?:
    | {
        __typename: 'HospitalShiftType';
        id: string;
        acceptedBid?: {
          id: string;
          review?: {
            id: string;
            overallScore: number;
            comment?: string | null;
          } | null;
        } | null;
      }
    | {
        __typename: 'RunType';
        id: string;
        acceptedBid?: {
          id: string;
          review?: {
            id: string;
            overallScore: number;
            comment?: string | null;
          } | null;
        } | null;
      }
    | {
        __typename: 'ShiftProxyType';
        id: string;
        acceptedBid?: {
          id: string;
          review?: {
            id: string;
            overallScore: number;
            comment?: string | null;
          } | null;
        } | null;
      }
    | null;
};

export type PastShiftsQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<ShiftFilterInput>;
}>;

export type PastShiftsQuery = {
  myPastShifts: {
    pageInfo: { endCursor?: string | null; hasNextPage: boolean };
    edges: Array<{
      node:
        | {
            __typename: 'HospitalShiftType';
            id: string;
            date: string;
            name: string;
            shiftType: string;
            status: string;
            acceptedBid?: {
              id: string;
              amount: string;
              review?: {
                id: string;
                overallScore: number;
                comment?: string | null;
              } | null;
            } | null;
            events: Array<
              | {
                  id: string;
                  startTime: any;
                  endTime: any;
                  date: string;
                  location: {
                    id: string;
                    name: string;
                    street1: string;
                    state: LocationLocationStateChoices;
                    zipCode: string;
                  };
                }
              | {
                  id: string;
                  startTime: any;
                  endTime: any;
                  date: string;
                  location: {
                    id: string;
                    name: string;
                    street1: string;
                    state: LocationLocationStateChoices;
                    zipCode: string;
                  };
                }
            >;
          }
        | {
            __typename: 'RunType';
            id: string;
            date: string;
            name: string;
            shiftType: string;
            status: string;
            acceptedBid?: {
              id: string;
              amount: string;
              review?: {
                id: string;
                overallScore: number;
                comment?: string | null;
              } | null;
            } | null;
            events: Array<
              | {
                  id: string;
                  startTime: any;
                  endTime: any;
                  date: string;
                  location: {
                    id: string;
                    name: string;
                    street1: string;
                    state: LocationLocationStateChoices;
                    zipCode: string;
                  };
                }
              | {
                  id: string;
                  startTime: any;
                  endTime: any;
                  date: string;
                  location: {
                    id: string;
                    name: string;
                    street1: string;
                    state: LocationLocationStateChoices;
                    zipCode: string;
                  };
                }
            >;
          }
        | {
            __typename: 'ShiftProxyType';
            id: string;
            date: string;
            name: string;
            shiftType: string;
            status: string;
            acceptedBid?: {
              id: string;
              amount: string;
              review?: {
                id: string;
                overallScore: number;
                comment?: string | null;
              } | null;
            } | null;
            events: Array<
              | {
                  id: string;
                  startTime: any;
                  endTime: any;
                  date: string;
                  location: {
                    id: string;
                    name: string;
                    street1: string;
                    state: LocationLocationStateChoices;
                    zipCode: string;
                  };
                }
              | {
                  id: string;
                  startTime: any;
                  endTime: any;
                  date: string;
                  location: {
                    id: string;
                    name: string;
                    street1: string;
                    state: LocationLocationStateChoices;
                    zipCode: string;
                  };
                }
            >;
          };
    }>;
  };
};

export type RequestCancelationMutationVariables = Exact<{
  cancelBidRequest: CancelBidRequestInput;
}>;

export type RequestCancelationMutation = {
  cancelBidRequest?: {
    success: boolean;
    cancelationRequest?: {
      id: string;
      bid: {
        id: string;
        finalStatus: BidsBidFinalStatusChoices;
        cancelationRequest?: {
          id: string;
          status: BidsBidCancelationRequestStatusChoices;
        } | null;
      };
    } | null;
  } | null;
};

export type ReviewConcernsQueryVariables = Exact<{ [key: string]: never }>;

export type ReviewConcernsQuery = {
  reviewConcerns: Array<{ id: string; description: string }>;
};

export type ReviewShiftMutationVariables = Exact<{
  bidId: Scalars['ID']['input'];
  bidReview?: InputMaybe<BidReviewInput>;
}>;

export type ReviewShiftMutation = { bidReview?: { success: boolean } | null };

export type UpcomingShiftsQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<ShiftFilterInput>;
}>;

export type UpcomingShiftsQuery = {
  myUpcomingShifts: {
    pageInfo: { endCursor?: string | null; hasNextPage: boolean };
    edges: Array<{
      node:
        | {
            __typename: 'HospitalShiftType';
            id: string;
            date: string;
            name: string;
            shiftType: string;
            status: string;
            acceptedBid?: {
              id: string;
              amount: string;
              finalStatus: BidsBidFinalStatusChoices;
              cancelationRequest?: {
                id: string;
                status: BidsBidCancelationRequestStatusChoices;
              } | null;
            } | null;
            events: Array<
              | {
                  id: string;
                  startTime: any;
                  endTime: any;
                  date: string;
                  location: {
                    id: string;
                    name: string;
                    street1: string;
                    state: LocationLocationStateChoices;
                    city: string;
                    zipCode: string;
                    timezone?: string | null;
                    phoneNumber?: string | null;
                    dispatchDistrict: {
                      clinicLeaders?: Array<{
                        name?: string | null;
                        phoneNumber: string;
                      } | null> | null;
                      hospitalLeaders?: Array<{
                        name?: string | null;
                        phoneNumber: string;
                      } | null> | null;
                    };
                  };
                }
              | {
                  id: string;
                  startTime: any;
                  endTime: any;
                  date: string;
                  location: {
                    id: string;
                    name: string;
                    street1: string;
                    state: LocationLocationStateChoices;
                    city: string;
                    zipCode: string;
                    timezone?: string | null;
                    phoneNumber?: string | null;
                    dispatchDistrict: {
                      clinicLeaders?: Array<{
                        name?: string | null;
                        phoneNumber: string;
                      } | null> | null;
                      hospitalLeaders?: Array<{
                        name?: string | null;
                        phoneNumber: string;
                      } | null> | null;
                    };
                  };
                }
            >;
          }
        | {
            __typename: 'RunType';
            id: string;
            date: string;
            name: string;
            shiftType: string;
            status: string;
            acceptedBid?: {
              id: string;
              amount: string;
              finalStatus: BidsBidFinalStatusChoices;
              cancelationRequest?: {
                id: string;
                status: BidsBidCancelationRequestStatusChoices;
              } | null;
            } | null;
            events: Array<
              | {
                  id: string;
                  startTime: any;
                  endTime: any;
                  date: string;
                  location: {
                    id: string;
                    name: string;
                    street1: string;
                    state: LocationLocationStateChoices;
                    city: string;
                    zipCode: string;
                    timezone?: string | null;
                    phoneNumber?: string | null;
                    dispatchDistrict: {
                      clinicLeaders?: Array<{
                        name?: string | null;
                        phoneNumber: string;
                      } | null> | null;
                      hospitalLeaders?: Array<{
                        name?: string | null;
                        phoneNumber: string;
                      } | null> | null;
                    };
                  };
                }
              | {
                  id: string;
                  startTime: any;
                  endTime: any;
                  date: string;
                  location: {
                    id: string;
                    name: string;
                    street1: string;
                    state: LocationLocationStateChoices;
                    city: string;
                    zipCode: string;
                    timezone?: string | null;
                    phoneNumber?: string | null;
                    dispatchDistrict: {
                      clinicLeaders?: Array<{
                        name?: string | null;
                        phoneNumber: string;
                      } | null> | null;
                      hospitalLeaders?: Array<{
                        name?: string | null;
                        phoneNumber: string;
                      } | null> | null;
                    };
                  };
                }
            >;
          }
        | {
            __typename: 'ShiftProxyType';
            id: string;
            date: string;
            name: string;
            shiftType: string;
            status: string;
            acceptedBid?: {
              id: string;
              amount: string;
              finalStatus: BidsBidFinalStatusChoices;
              cancelationRequest?: {
                id: string;
                status: BidsBidCancelationRequestStatusChoices;
              } | null;
            } | null;
            events: Array<
              | {
                  id: string;
                  startTime: any;
                  endTime: any;
                  date: string;
                  location: {
                    id: string;
                    name: string;
                    street1: string;
                    state: LocationLocationStateChoices;
                    city: string;
                    zipCode: string;
                    timezone?: string | null;
                    phoneNumber?: string | null;
                    dispatchDistrict: {
                      clinicLeaders?: Array<{
                        name?: string | null;
                        phoneNumber: string;
                      } | null> | null;
                      hospitalLeaders?: Array<{
                        name?: string | null;
                        phoneNumber: string;
                      } | null> | null;
                    };
                  };
                }
              | {
                  id: string;
                  startTime: any;
                  endTime: any;
                  date: string;
                  location: {
                    id: string;
                    name: string;
                    street1: string;
                    state: LocationLocationStateChoices;
                    city: string;
                    zipCode: string;
                    timezone?: string | null;
                    phoneNumber?: string | null;
                    dispatchDistrict: {
                      clinicLeaders?: Array<{
                        name?: string | null;
                        phoneNumber: string;
                      } | null> | null;
                      hospitalLeaders?: Array<{
                        name?: string | null;
                        phoneNumber: string;
                      } | null> | null;
                    };
                  };
                }
            >;
          };
    }>;
  };
};

export type AddInsuranceMutationVariables = Exact<{
  insurance: InsuranceInput;
}>;

export type AddInsuranceMutation = {
  addInsurance?: {
    success: boolean;
    error?:
      | {
          validationErrors?: Array<{
            field?: string | null;
            messages?: Array<string | null> | null;
          } | null> | null;
        }
      | {}
      | null;
    vetProfile?: {
      id: string;
      insurances: Array<{
        id: string;
        expirationDate: string;
        document: string;
        policyNumber: string;
      }>;
    } | null;
  } | null;
};

export type AddLicenseMutationVariables = Exact<{
  license: LicenseInput;
}>;

export type AddLicenseMutation = {
  addLicense?: {
    success: boolean;
    error?:
      | {
          validationErrors?: Array<{
            field?: string | null;
            messages?: Array<string | null> | null;
          } | null> | null;
        }
      | {}
      | null;
    vetProfile?: {
      id: string;
      licenses: Array<{
        id: string;
        expirationDate: string;
        document: string;
        stateCode: AccountVetLicenseStateCodeChoices;
        number: string;
      }>;
    } | null;
  } | null;
};

export type AddRegistrationMutationVariables = Exact<{
  registration: RegistrationInput;
}>;

export type AddRegistrationMutation = {
  addRegistration?: {
    success: boolean;
    error?:
      | {
          validationErrors?: Array<{
            field?: string | null;
            messages?: Array<string | null> | null;
          } | null> | null;
        }
      | {}
      | null;
    vetProfile?: {
      id: string;
      deaRegistrations: Array<{
        id: string;
        expirationDate: string;
        document: string;
        stateCode: AccountDeaRegistrationStateCodeChoices;
        number: string;
      }>;
    } | null;
  } | null;
};

export type AvailableTokensQueryVariables = Exact<{ [key: string]: never }>;

export type AvailableTokensQuery = {
  me?: {
    id: string;
    vetProfile?: {
      id: string;
      allowBuyItNow: boolean;
      availableTokenCount?: number | null;
    } | null;
  } | null;
};

export type BasicProfileQueryVariables = Exact<{ [key: string]: never }>;

export type BasicProfileQuery = {
  me?: {
    id: string;
    firstName: string;
    lastName: string;
    dateJoined: any;
    vetProfile?: {
      id: string;
      verifiedInfo: boolean;
      askForNetPromoterScore?: boolean | null;
      licenses: Array<{
        id: string;
        expirationDate: string;
        number: string;
        stateCode: AccountVetLicenseStateCodeChoices;
      }>;
    } | null;
  } | null;
};

export type CreateNpsMutationVariables = Exact<{
  npsScore?: InputMaybe<NetPromoterScoreInput>;
}>;

export type CreateNpsMutation = {
  createNetPromoterScore?: {
    success: boolean;
    error?:
      | {
          validationErrors?: Array<{
            field?: string | null;
            messages?: Array<string | null> | null;
          } | null> | null;
        }
      | {}
      | null;
  } | null;
};

export type EditInsuranceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  insurance: InsuranceInput;
}>;

export type EditInsuranceMutation = {
  editInsurance?: {
    success: boolean;
    error?:
      | {
          validationErrors?: Array<{
            field?: string | null;
            messages?: Array<string | null> | null;
          } | null> | null;
        }
      | {}
      | null;
    vetProfile?: {
      id: string;
      insurances: Array<{
        id: string;
        expirationDate: string;
        document: string;
        policyNumber: string;
      }>;
    } | null;
  } | null;
};

export type EditLicenseMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  license: LicenseInput;
}>;

export type EditLicenseMutation = {
  editLicense?: {
    success: boolean;
    error?:
      | {
          validationErrors?: Array<{
            field?: string | null;
            messages?: Array<string | null> | null;
          } | null> | null;
        }
      | {}
      | null;
    vetProfile?: {
      id: string;
      licenses: Array<{
        id: string;
        expirationDate: string;
        document: string;
        stateCode: AccountVetLicenseStateCodeChoices;
        number: string;
      }>;
    } | null;
  } | null;
};

export type EditProfileMutationVariables = Exact<{
  vetProfile: VetProfileInput;
}>;

export type EditProfileMutation = {
  editVetProfile?: {
    success: boolean;
    error?:
      | {
          validationErrors?: Array<{
            field?: string | null;
            messages?: Array<string | null> | null;
          } | null> | null;
        }
      | {}
      | null;
    vetProfile?: {
      id: string;
      phoneNumber: string;
      profilePic?: string | null;
    } | null;
  } | null;
};

export type EditRegistrationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  registration: RegistrationInput;
}>;

export type EditRegistrationMutation = {
  editRegistration?: {
    success: boolean;
    error?:
      | {
          validationErrors?: Array<{
            field?: string | null;
            messages?: Array<string | null> | null;
          } | null> | null;
        }
      | {}
      | null;
    vetProfile?: {
      id: string;
      deaRegistrations: Array<{
        id: string;
        expirationDate: string;
        document: string;
        stateCode: AccountDeaRegistrationStateCodeChoices;
        number: string;
      }>;
    } | null;
  } | null;
};

export type FullProfileQueryVariables = Exact<{
  year: Scalars['Int']['input'];
}>;

export type FullProfileQuery = {
  me?: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    dateJoined: any;
    vetProfile?: {
      id: string;
      petcoUserId?: string | null;
      verifiedInfo: boolean;
      phoneNumber: string;
      profilePic?: string | null;
      city?: string | null;
      state?: AccountVetProfileStateChoices | null;
      zipcode?: string | null;
      address?: string | null;
      clinics?: number | null;
      total?: number | null;
      licenses: Array<{
        id: string;
        expirationDate: string;
        document: string;
        stateCode: AccountVetLicenseStateCodeChoices;
        number: string;
      }>;
      insurances: Array<{
        id: string;
        expirationDate: string;
        document: string;
        policyNumber: string;
      }>;
      deaRegistrations: Array<{
        id: string;
        expirationDate: string;
        document: string;
        stateCode: AccountDeaRegistrationStateCodeChoices;
        number: string;
      }>;
    } | null;
  } | null;
  validCoupon?: {
    barcode: string;
    expirationDate: string;
    discountPercentage: number;
  } | null;
};

export type UploadUrlMutationVariables = Exact<{
  files:
    | Array<InputMaybe<FileSignatureInputType>>
    | InputMaybe<FileSignatureInputType>;
}>;

export type UploadUrlMutation = {
  generateUploadSignatures?: {
    success: boolean;
    presignedPosts?: Array<any | null> | null;
    error?:
      | { __typename: 'ExecutionError'; errorMessage: string }
      | {
          __typename: 'ValidationErrors';
          validationErrors?: Array<{
            field?: string | null;
            messages?: Array<string | null> | null;
          } | null> | null;
        }
      | null;
  } | null;
};

export const BidFinalStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'bidFinalStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bid' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'finalStatus' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BidFinalStatusQuery, BidFinalStatusQueryVariables>;
export const GetMyBidsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getMyBids' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cursor' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '12' },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'shiftTypes' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'status' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'startDate' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'endDate' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'locationName' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'states' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'orderBy' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myBids' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'cursor' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'first' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'shiftTypes' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'shiftTypes' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'status' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'startDate' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'startDate' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'endDate' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'endDate' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locationName' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locationName' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'name' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'name' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'states' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'states' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'orderBy' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasNextPage' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'amount' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'finalStatus' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'shift' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'date' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'shiftType' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'buyItNowAmount',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'allowShiftBuyItNow',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'allowBuyItNowToken',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'bidGuidanceText',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'minBidRange',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'maxBidRange',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'events' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'date' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'startTime',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'endTime',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'date' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'location',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'id',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'name',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'street1',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'state',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'zipCode',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'details',
                                                },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'pace',
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'featuredReviews',
                                                },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'id',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'overallScore',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'comment',
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetMyBidsQuery, GetMyBidsQueryVariables>;
export const OpenShiftsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'openShifts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cursor' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '12' },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filters' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ShiftFilterInput' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          defaultValue: { kind: 'StringValue', value: 'date', block: false },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'availableShifts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'cursor' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'first' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filters' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sort' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasNextPage' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'date' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'shiftType' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hasValidLicense' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'bidGuidanceText' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'minBidRange' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'maxBidRange' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'allowShiftBuyItNow',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'allowBuyItNowToken',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'buyItNowAmount' },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'RunType' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'bidCount' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: {
                                  kind: 'Name',
                                  value: 'HospitalShiftType',
                                },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'bidCount' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'ShiftProxyType' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'bidCount' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'events' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'startTime' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'endTime' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'date' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'location' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'name' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'street1',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'state',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'zipCode',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'details',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'pace',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'dispatchDistrict',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value:
                                                    'allowShiftInfoVisibility',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'featuredReviews',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'id',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'overallScore',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'comment',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OpenShiftsQuery, OpenShiftsQueryVariables>;
export const PlaceBidsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'placeBids' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'bids' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'BidInput' },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createBids' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'bids' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'bids' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'error' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'ValidationErrors' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'validationErrors' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'field' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'messages' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PlaceBidsMutation, PlaceBidsMutationVariables>;
export const UpdateBidDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateBid' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'bid' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'EditBidInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'editBid' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'bid' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'bid' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bid' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateBidMutation, UpdateBidMutationVariables>;
export const WithdrawBidDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'withdrawBid' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'bid' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CancelBidInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancelBid' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'bid' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'bid' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bid' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'finalStatus' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WithdrawBidMutation, WithdrawBidMutationVariables>;
export const ContactRequestDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'contactRequest' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactRequest' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requestType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContactRequestQuery, ContactRequestQueryVariables>;
export const ContactRequestsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'contactRequests' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactRequests' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requestType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'section' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ContactRequestsQuery,
  ContactRequestsQueryVariables
>;
export const FaqSectionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'faqSection' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'section' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faq' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'section' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'section' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'question' } },
                { kind: 'Field', name: { kind: 'Name', value: 'answer' } },
                { kind: 'Field', name: { kind: 'Name', value: 'linkLabel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'link' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'documentName' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'document' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactRequests' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'section' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'section' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requestType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FaqSectionQuery, FaqSectionQueryVariables>;
export const SubmitContactRequestDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'submitContactRequest' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateContactRequestAnswerInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createContactRequestAnswer' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contactRequestAnswer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SubmitContactRequestMutation,
  SubmitContactRequestMutationVariables
>;
export const CancelationReasonsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'cancelationReasons' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancelationReasons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CancelationReasonsQuery,
  CancelationReasonsQueryVariables
>;
export const PastShiftReviewsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'pastShiftReviews' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'shiftType' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shift' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'shiftType' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'shiftType' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'RunType' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'acceptedBid' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'review' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'overallScore',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'comment' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'HospitalShiftType' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'acceptedBid' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'review' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'overallScore',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'comment' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ShiftProxyType' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'acceptedBid' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'review' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'overallScore',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'comment' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PastShiftReviewsQuery,
  PastShiftReviewsQueryVariables
>;
export const PastShiftsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'pastShifts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cursor' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '12' },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filters' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ShiftFilterInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myPastShifts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'cursor' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'first' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filters' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasNextPage' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'date' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'shiftType' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'RunType' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'acceptedBid',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'amount',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'review',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'id',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'overallScore',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'comment',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: {
                                  kind: 'Name',
                                  value: 'HospitalShiftType',
                                },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'acceptedBid',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'amount',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'review',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'id',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'overallScore',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'comment',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'ShiftProxyType' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'acceptedBid',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'amount',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'review',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'id',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'overallScore',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'comment',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'events' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'startTime' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'endTime' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'date' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'location' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'name' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'street1',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'state',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'zipCode',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PastShiftsQuery, PastShiftsQueryVariables>;
export const RequestCancelationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'requestCancelation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cancelBidRequest' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CancelBidRequestInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancelBidRequest' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cancelBidRequest' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'cancelBidRequest' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cancelationRequest' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bid' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'finalStatus' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'cancelationRequest',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'status' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RequestCancelationMutation,
  RequestCancelationMutationVariables
>;
export const ReviewConcernsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'reviewConcerns' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reviewConcerns' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReviewConcernsQuery, ReviewConcernsQueryVariables>;
export const ReviewShiftDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'reviewShift' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'bidId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'bidReview' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'BidReviewInput' },
          },
          defaultValue: { kind: 'NullValue' },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bidReview' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'bidId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'bidId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'bidReview' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'bidReview' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'reviewFromModal' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReviewShiftMutation, ReviewShiftMutationVariables>;
export const UpcomingShiftsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'upcomingShifts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cursor' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '12' },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filters' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ShiftFilterInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myUpcomingShifts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'cursor' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'first' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filters' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasNextPage' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'date' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'shiftType' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'RunType' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'acceptedBid',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'amount',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'finalStatus',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'cancelationRequest',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'id',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'status',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: {
                                  kind: 'Name',
                                  value: 'HospitalShiftType',
                                },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'acceptedBid',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'amount',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'finalStatus',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'cancelationRequest',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'id',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'status',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'ShiftProxyType' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'acceptedBid',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'amount',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'finalStatus',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'cancelationRequest',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'id',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'status',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'events' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'startTime' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'endTime' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'date' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'location' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'name' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'street1',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'state',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'city' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'zipCode',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'timezone',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'phoneNumber',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'dispatchDistrict',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'clinicLeaders',
                                                },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'name',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'phoneNumber',
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'hospitalLeaders',
                                                },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'name',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'phoneNumber',
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpcomingShiftsQuery, UpcomingShiftsQueryVariables>;
export const AddInsuranceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'addInsurance' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'insurance' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'InsuranceInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addInsurance' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'insurance' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'insurance' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'error' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'ValidationErrors' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'validationErrors' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'field' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'messages' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vetProfile' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'insurances' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'expirationDate' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'document' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'policyNumber' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddInsuranceMutation,
  AddInsuranceMutationVariables
>;
export const AddLicenseDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'addLicense' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'license' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LicenseInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addLicense' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'license' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'license' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'error' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'ValidationErrors' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'validationErrors' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'field' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'messages' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vetProfile' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'licenses' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'expirationDate' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'document' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stateCode' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'number' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddLicenseMutation, AddLicenseMutationVariables>;
export const AddRegistrationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'addRegistration' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'registration' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RegistrationInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addRegistration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'registration' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'registration' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'error' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'ValidationErrors' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'validationErrors' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'field' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'messages' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vetProfile' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deaRegistrations' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'expirationDate' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'document' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stateCode' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'number' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddRegistrationMutation,
  AddRegistrationMutationVariables
>;
export const AvailableTokensDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'availableTokens' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vetProfile' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'allowBuyItNow' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'availableTokenCount' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AvailableTokensQuery,
  AvailableTokensQueryVariables
>;
export const BasicProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'basicProfile' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dateJoined' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vetProfile' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'verifiedInfo' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'askForNetPromoterScore' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'licenses' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'expirationDate' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'number' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stateCode' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BasicProfileQuery, BasicProfileQueryVariables>;
export const CreateNpsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createNPS' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'npsScore' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'NetPromoterScoreInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createNetPromoterScore' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'npsScore' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'npsScore' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'error' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'ValidationErrors' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'validationErrors' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'field' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'messages' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateNpsMutation, CreateNpsMutationVariables>;
export const EditInsuranceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'editInsurance' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'insurance' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'InsuranceInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'editInsurance' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'insurance' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'insurance' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'error' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'ValidationErrors' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'validationErrors' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'field' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'messages' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vetProfile' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'insurances' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'expirationDate' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'document' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'policyNumber' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EditInsuranceMutation,
  EditInsuranceMutationVariables
>;
export const EditLicenseDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'editLicense' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'license' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LicenseInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'editLicense' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'license' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'license' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'error' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'ValidationErrors' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'validationErrors' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'field' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'messages' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vetProfile' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'licenses' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'expirationDate' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'document' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stateCode' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'number' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EditLicenseMutation, EditLicenseMutationVariables>;
export const EditProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'editProfile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'vetProfile' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VetProfileInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'editVetProfile' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'vetProfile' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'vetProfile' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'error' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'ValidationErrors' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'validationErrors' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'field' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'messages' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vetProfile' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'phoneNumber' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'profilePic' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EditProfileMutation, EditProfileMutationVariables>;
export const EditRegistrationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'editRegistration' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'registration' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RegistrationInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'editRegistration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'registration' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'registration' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'error' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'ValidationErrors' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'validationErrors' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'field' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'messages' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vetProfile' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deaRegistrations' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'expirationDate' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'document' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stateCode' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'number' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EditRegistrationMutation,
  EditRegistrationMutationVariables
>;
export const FullProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fullProfile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'year' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dateJoined' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vetProfile' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'petcoUserId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'verifiedInfo' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'phoneNumber' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'profilePic' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'zipcode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'clinics' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'year' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'year' },
                            },
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'total' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'year' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'year' },
                            },
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'licenses' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'expirationDate' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'document' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stateCode' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'number' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'insurances' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'expirationDate' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'document' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'policyNumber' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deaRegistrations' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'expirationDate' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'document' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stateCode' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'number' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'validCoupon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'barcode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expirationDate' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'discountPercentage' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FullProfileQuery, FullProfileQueryVariables>;
export const UploadUrlDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'uploadUrl' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'files' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'FileSignatureInputType' },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generateUploadSignatures' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'files' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'files' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'presignedPosts' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'error' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'ValidationErrors' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'validationErrors' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'field' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'messages' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'ExecutionError' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'errorMessage' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UploadUrlMutation, UploadUrlMutationVariables>;
